import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { PaginatedResponse } from "types/response";
import { Share } from "types/share";
import Error from "types/error";
import { generatePath } from "react-router-dom";

export default function useBlockShares(
  blockId: string,
  page?: number,
  size?: number,
  search?: Record<string, string>
) {
  const request: Request = {
    url: generatePath(ENDPOINTS.shares.block, { id: blockId }),
    config: {
      method: "GET",
      params: { page, size, ...search },
    },
  };

  const requestConfig = {
    queryKey: [
      ENDPOINTS.shares.block,
      blockId,
      page,
      size,
      search && JSON.stringify(search),
    ],
    queryFn: () => client(request).then((res) => res.data),
  };

  const { data, ...rest } = useQuery<PaginatedResponse<Share[]>, Error>(
    requestConfig
  );

  return { data, ...rest };
}
